import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { useAppDispatch } from "@/store";
import { useLayoutActions } from "@/store/layout";
import { ElementType } from "react";
import { useMatch, useNavigate, useResolvedPath } from "react-router";

type SideMenuButtonProps = {
    text: string;
    icon: ElementType;
    link: string;
};

export default function SideMenuButton({icon: Icon, text, link }: SideMenuButtonProps) {
    const navigate = useNavigate();
    const {setDrawer} = useLayoutActions;
    const dispatch = useAppDispatch();
    const downSm = window.matchMedia('(max-width: 640px)').matches;
    const resolved = useResolvedPath(link);
    const match = useMatch({ path: resolved.pathname, end: true});


    function handleNavigate(path: string){
        navigate(path);
        if(downSm) {
            dispatch(setDrawer(false));
        }
    }

    return (
        <SidebarMenuItem className="bg-white shadow-sm shadow-gray-500 rounded-3xl " >
            <SidebarMenuButton className="rounded-3xl" asChild isActive={Boolean(match)}  size="lg" >
                <button type="button" onClick={() => handleNavigate(link)}>
                    <Icon />
                    <span className="text-lg">{text}</span>
                </button>
            </SidebarMenuButton>
        </SidebarMenuItem>
        
    );
}